import {Switch} from "react-router-dom";
import {Route} from "../generic";
import PersonalData from "./ProfileData";
import EventsProfile from "./EventsProfile";
import CertificatesProfile from "./CertificatesProfile";
import SeasonTicketProfile from "./SeasonTicketProfile";
import NotificationsProfile from "./NotificationsProfile";
import WithProfileNavigation from "../../lib/utils/hocs/WithProfileNavigation";
import AccountActionsProfile from "./AccountActionsProfile";

const ProfileRoutes = () => {
    return (
        <WithProfileNavigation>
            <Switch>
                <Route exact path={"/me/"} component={EventsProfile}/>
                <Route path={"/me/personal-data"} component={PersonalData}/>
                <Route path={"/me/events"} component={EventsProfile}/>
                <Route path={"/me/certificates"} component={CertificatesProfile}/>
                <Route path={"/me/season-ticket"} component={SeasonTicketProfile}/>
                <Route path={"/me/notifications"} component={NotificationsProfile}/>
                <Route path={"/me/actions-account"} component={AccountActionsProfile}/>
            </Switch>
        </WithProfileNavigation>
    )
}

export default ProfileRoutes;